import EmailIcon from '@mui/icons-material/Email'
import LockIcon from '@mui/icons-material/Lock'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import { List, ListItemButton, ListItemIcon, ListItemText, styled } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useCallback } from 'react'
import { logoutRequest } from 'api/auth'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../../routes/routes'
import { useActions } from '../../../store/hooks'
import { useAuthContext } from '../../context/AuthProvider'
import { useDrawersContext } from '../../context/ClientsDrawersProvider'
import { timeMeasureSystem } from '../../context/TimeMeasureSystem'

interface Props {
  setOpen: (isShow: boolean) => void
}

const ProfileList = (props: Props) => {
  const { setOpen } = props
  const { logout } = useActions()

  const navigate = useNavigate()
  const { clearUserData } = useAuthContext()
  const { handleOpenChangePasswordDrawer, handleOpenContactUs } = useDrawersContext()

  const onClickContactUs = useCallback(() => {
    setOpen(false)
    handleOpenContactUs()
  }, [handleOpenContactUs, setOpen])

  const onClickChangePassword = () => {
    handleOpenChangePasswordDrawer()
    setOpen(false)
  }

  const handleLogout = () => {
    timeMeasureSystem.stopUserSession()
    void logoutRequest().finally(() => {
      logout()
      navigate(routes.signIn)
      clearUserData()
    })
  }

  const changePassword = <Typography variant="body1">Change Password</Typography>
  const logoutText = <Typography variant="body1">Logout</Typography>
  const contactUsText = <Typography variant="body1">Contact Us</Typography>

  return (
    <StyledList component="nav">
      <ListItemButton onClick={onClickChangePassword}>
        <ListItemIcon>
          <LockIcon />
        </ListItemIcon>
        <ListItemText primary={changePassword} />
      </ListItemButton>

      <ListItemButton onClick={onClickContactUs}>
        <ListItemIcon>
          <EmailIcon />
        </ListItemIcon>
        <ListItemText primary={contactUsText} />
      </ListItemButton>

      <ListItemButton onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={logoutText} />
      </ListItemButton>
    </StyledList>
  )
}

export default ProfileList

const StyledList = styled(List)<{ component?: React.ElementType }>(({ theme }) => ({
  padding: 0,
  '& .MuiListItemIcon-root': {
    minWidth: 32,
    color: theme.palette.grey[500],
  },
}))
